// extracted by mini-css-extract-plugin
module.exports = {"warrantyBadgeButton":"az_EIb","warrantyBadgeText":"az_FIb","smallPadding":"az_GIb"};